import agroLogo from "../../assets/communities/agro.png";
import artLogo from "../../assets/communities/art.png";
import beautyLogo from "../../assets/communities/beauty.jpeg";
import mktLogo from "../../assets/communities/bold_minds.png";
import bootsLogo from "../../assets/communities/boots.jpeg";
import financeLogo from "../../assets/communities/finance.png";
import realStateLogo from "../../assets/communities/real_state.png";
import techLogo from "../../assets/communities/tech.PNG";

import BoletimSection from "../BoletimSection/BoletimSection";
import BoletimSubsection from "../BoletimSubsection/BoletimSubsection";
import Box from "../Box/Box";
import ProgressBar from "../ProgressBar/ProgressBar";

import Card from "./Card/Card";
import styles from "./ComunidadesHubs.module.css";

function ComunidadesHubs({ comunidades }) {
	const COMMUNITIES = [
		{
			hubs: comunidades.agro.hubs,
			total: comunidades.agro.total,
			image: agroLogo,
			disabled: comunidades.agro.active ? false : true,
			show: true,
		},
		{
			hubs: comunidades.artes.hubs,
			total: comunidades.artes.total,
			image: artLogo,
			disabled: comunidades.artes.active ? false : true,
			show: true,
		},
		{
			hubs: comunidades.beauty.hubs,
			total: comunidades.beauty.total,
			image: beautyLogo,
			disabled: comunidades.beauty.active ? false : true,
			show: true,
		},
		{
			hubs: comunidades.bold_minds.hubs,
			total: comunidades.bold_minds.total,
			image: mktLogo,
			disabled: comunidades.bold_minds.active ? false : true,
			show: true,
		},
		{
			hubs: comunidades.boots.hubs,
			total: comunidades.boots.total,
			image: bootsLogo,
			disabled: comunidades.boots.active ? false : true,
			show: true,
		},
		{
			hubs: comunidades.finance.hubs,
			total: comunidades.finance.total,
			image: financeLogo,
			disabled: comunidades.finance.active ? false : true,
			show: true,
		},
		{
			hubs: comunidades.real_estate.hubs,
			total: comunidades.real_estate.total,
			image: realStateLogo,
			disabled: comunidades.real_estate.active ? false : true,
			show: true,
		},
		{
			hubs: comunidades.tech.hubs,
			total: comunidades.tech.total,
			image: techLogo,
			disabled: comunidades.tech.active ? false : true,
			show: true,
		},
	];

	return (
		<BoletimSection
			title="Comunidades"
			icon="group"
		>
			<BoletimSubsection
				subtitle={"Participações em Hubs ofertados"}
			>
				<div className={styles.container}>
					{COMMUNITIES.map(
						({ image, disabled, show, hubs, total }, i) => {
							if (show) {
								return (
									<>
										<Box size={12} />
										<ProgressBar
											title={
												<Card
													image={image}
													disabled={disabled}
													onlyImage={true}
												/>
											}
											isTitleImg={true}
											disabled={disabled}
											value={hubs}
											maxValue={total}
											valueType=" hubs"
										/>
										{i + 1 == COMMUNITIES.length && (
											<Box size={24} />
										)}
									</>
								);
							}
						},
					)}
				</div>
			</BoletimSubsection>
		</BoletimSection>
	);
}

export default ComunidadesHubs;
